<template>
    <v-overlay class="maintenance-overlay" :z-index="2000">
        <v-card class="dialog-card">
            <iframe src="/maintenance.html" class="frame"></iframe>
        </v-card>
    </v-overlay>
</template>

<script>
import { onMounted, onUnmounted } from "@vue/composition-api";
export default {
    name: 'MaintenanceDialog',
    setup(props, context) {
        const receiveMessage = (event) => {
            if(event.origin === window.location.origin) {
                if(event.data === 'reload') window.location.reload()
                if(event.data === 'close') context.emit('close')
            }
        }
        onMounted(() => {
          window.addEventListener('message', receiveMessage)
        })
        onUnmounted(() => {
            window.removeEventListener('message', receiveMessage)
        })
    }
}
</script>
<style scoped>
.dialog-card {
    background: transparent;
    height: 100vh;
    width: 100vw;
    z-index: 2002!important;
}
.frame {
    border: 0;
    height: 100%;
    width: 100%;
}
</style>
